import React from "react";
import Plans from "../components/Plans";
import CoinCryptoConverter from "../components/CryptoConverter";

const OurPlans = () => {
  return (
    <div className="font-lato">
      <section className="relative bg-gradient-to-r from-blue-900 to-orange-500 text-white py-40 px-6 h-[100vh]">
        <div className="container mx-auto flex flex-col items-center text-center">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
            Invest in Your Future Today
          </h1>
          <p className="text-lg md:text-xl mb-8">
            Explore our curated investment plans designed to help you build
            wealth, secure your future, and achieve your financial goals.
            Whether you're a beginner or an experienced investor, we have
            options tailored just for you.
          </p>

          <div className="flex gap-4">
            {/* Primary CTA */}
            <a
              href="/login"
              className="bg-secondary-500 text-black py-3 px-8 rounded-lg text-xl font-semibold transition-all hover:bg-secondary-600 hover:scale-105"
            >
              Get Started Now
            </a>
          </div>

          {/* Optional testimonial or trust badge */}
          <div className="mt-8 text-sm italic text-gray-200">
            Trusted by over 10,000 investors worldwide
          </div>
        </div>

        {/* Optional Background image or animation */}
        {/* <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: "url('https://via.placeholder.com/1500x900')" }}></div> */}
      </section>

      <Plans />

      <div className="flex justify-center items-center flex-col p-10 ">
        <h2
          className={`font-lato md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px] text-center my-10 text-primary-950`}
        >
          Crypto Calculator
        </h2>
        <CoinCryptoConverter />
      </div>
    </div>
  );
};

export default OurPlans;
